import { OnErrorCallback } from '@bugsnag/core/types/common';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { initLogging } from '@propertypal/shared/src/services/logging';
import appConfig from '../../../../app.config.json';
import { logCrumb, logError } from './logging';

export const onError: OnErrorCallback = (event) => {
  // Ignore errors from older browsers
  if (typeof window !== 'undefined' && !('IntersectionObserver' in window)) {
    return false;
  }

  let shouldSend = true;

  event.errors.forEach((error) => {
    // Do not log minified react error
    if (error.errorMessage.includes('Minified React error')) {
      shouldSend = false;
    }

    // Blacklist errors from ad scripts
    if (error.stacktrace) {
      error.stacktrace.forEach((trace) => {
        if (
          trace.file &&
          // eslint-disable-next-line max-len
          /(prebid\.lib\.js|quantcast\.lib\.js|amazon-adsystem|csm_|securepubads\.g\.doubleclick|pagead2\.googlesyndication)/g.test(
            trace.file,
          )
        ) {
          shouldSend = false;
        }
      });
    }
  });

  return shouldSend;
};

Bugsnag.start({
  apiKey: appConfig.bugsnagApiKey,
  // @ts-ignore
  plugins: typeof window === 'undefined' ? [] : [new BugsnagPluginReact()],
  releaseStage: appConfig.env,
  appVersion: `${appConfig.appVersion}.${appConfig.env}`,
  // @ts-ignore
  onError,
});

initLogging({
  logCrumb,
  logError,
});

export default {};
